import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      paddingTop: 0,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/LicensedStates/useStyles.js